import { render, staticRenderFns } from "./NewVersionPopUp.vue?vue&type=template&id=2d2c0ff6&scoped=true&"
import script from "./NewVersionPopUp.vue?vue&type=script&lang=ts&"
export * from "./NewVersionPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./NewVersionPopUp.vue?vue&type=style&index=0&id=2d2c0ff6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c0ff6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
